// Investiture
import React from 'react';
import Englishcca2class2025 from '../views/Englishcca2class2025';

const InvestiturePage = () => {
  return <Englishcca2class2025 />;
};

export default InvestiturePage;
